module.exports = __webpack_public_path__ + "img/40_38_020_190.4c1ea132.jpg";